var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatTrainingYoga(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 2.5)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8.75C1.60051 8.75-.75 11.1005-.75 14 -.75 16.8995 1.60051 19.25 4.5 19.25 7.3995 19.25 9.75 16.8995 9.75 14 9.75 11.1005 7.3995 8.75 4.5 8.75ZM4.5 10.25C6.57107 10.25 8.25 11.9289 8.25 14 8.25 16.0711 6.57107 17.75 4.5 17.75 2.42893 17.75.75 16.0711.75 14 .75 11.9289 2.42893 10.25 4.5 10.25Z",
    stroke: "none",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3.75C17.4625 3.75 18.6584 4.8917 18.745 6.33248L18.75 6.5V16.5C18.75 17.9625 17.6083 19.1584 16.1675 19.245L16 19.25H4.5C4.08579 19.25 3.75 18.9142 3.75 18.5 3.75 18.1203 4.03215 17.8065 4.39823 17.7568L4.5 17.75H16C16.6472 17.75 17.1795 17.2581 17.2435 16.6278L17.25 16.5V6.5C17.25 5.85279 16.7581 5.32047 16.1278 5.25645L16 5.25H9C8.58579 5.25 8.25 4.91421 8.25 4.5 8.25 4.1203 8.53215 3.80651 8.89823 3.75685L9 3.75H16Z",
    stroke: "none",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5-.75C7.32701-.75 9.63213 1.48445 9.74562 4.2836L9.75 4.5V14C9.75 14.4142 9.41421 14.75 9 14.75 8.6203 14.75 8.30651 14.4678 8.25685 14.1018L8.25 14V4.5C8.25 2.42893 6.57107.75 4.5.75 2.49574.75.858726 2.32236.755198 4.30084L.75 4.5V14C.75 14.4142.414214 14.75 0 14.75 -.379696 14.75-.693491 14.4678-.743153 14.1018L-.75 14V4.5C-.75 1.60051 1.60051-.75 4.5-.75Z",
    stroke: "none",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.39823 13.2068L4.5 13.2 4.612 13.208 4.69698 13.2244C5.01205 13.3042 5.25263 13.5709 5.29377 13.8996L5.3 14C5.3 14.4418 4.94183 14.8 4.5 14.8 4.05817 14.8 3.7 14.4418 3.7 14 3.7 13.6261 3.95644 13.3122 4.30302 13.2244L4.39823 13.2068Z",
    stroke: "none",
    fill: "#323232"
  }))), /*#__PURE__*/React.createElement("rect", {
    fillRule: "evenodd",
    stroke: "none",
    width: 24,
    height: 24,
    fill: "none"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatTrainingYoga);
export default __webpack_public_path__ + "static/media/mat-training-yoga.dff9e39a47b35ecddf19f24f6c162b16.svg";
export { ForwardRef as ReactComponent };